const dic = JSON.parse(localStorage.dic);
import { filterTime } from '@/api/filter';
const POLICY_STATUS = dic['POLICY_STATUS'];
const PRODUCT_TYPE2 = dic['PRODUCT_TYPE2'];
const SUPPLIERS = dic['SUPPLIERS'];
const CURRENCY_TYPE = dic['CURRENCY_TYPE'];
const GUARANTEE_TYPE = dic['GUARANTEE_TYPE'];
const IFA_RANK = dic['IFA_RANK'];
export const config = {
  mixins: [],
  data() {
    return {
      columns: [],
      extraColumns: []
    };
  },
  methods: {
    getColumns() {
      this.columns = [
        {
          type: "selection",
          width: 60,
          align: "center",
          fixed: 'left'
        },
        {
          title: '保单编号',
          align: 'center',
          key: 'policyNo',
          minWidth: 160,
          fixed: 'left',
          render(h, params) {
            const icon = params.row.isReferral == 1 ? <Icon type="md-star" style="margin-right: 4px;" /> : null;
            return <div>{icon}{params.row.policyNo}</div>;
          }
        },
        {
          title: '所属团队',
          align: 'center',
          key: 'groupName',
          minWidth: 170
        },
        {
          title: '保单状态',
          align: 'center',
          key: 'policyStatus',
          minWidth: 90,
          render(h, params) {
            let policyStatus = params.row.policyStatus;
            return <span>{POLICY_STATUS[policyStatus]}</span>;
          }
        },
        {
          title: '保单期数',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 80
        },
        {
          title: '供应商',
          align: 'center',
          key: 'suppliers',
          minWidth: 90,
          render(h, params) {
            let suppliers = params.row.suppliers;
            return <span>{SUPPLIERS[suppliers]}</span>;
          }
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 90
        },
        {
          title: '产品名称',
          align: 'center',
          key: 'productName',
          minWidth: 220
        },
        {
          title: '产品类型',
          align: 'center',
          key: 'productType',
          minWidth: 110,
          render(h, params) {
            let productType = params.row.productType;
            return <span>{PRODUCT_TYPE2[productType]}</span>;
          }

        },
        {
          title: '签单日期',
          align: 'center',
          key: 'signDate',
          minWidth: 120,
          render(h, params) {
            let signDate = params.row.signDate;
            return <span>{filterTime(signDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectDate',
          minWidth: 120,
          render(h, params) {
            let effectDate = params.row.effectDate;
            return <span>{filterTime(effectDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '冷静期截止日',
          align: 'center',
          key: 'expirationDate',
          minWidth: 120,
          render(h, params) {
            let expirationDate = params.row.expirationDate;
            return <span>{filterTime(expirationDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '投保人/受保人',
          align: 'center',
          key: 'holderName',
          minWidth: 180,
          render(h, params) {
            let holderName = params.row.holderName;
            let insuranceName = params.row.insuranceName;
            return <span>{holderName || '-'}/{insuranceName || '-'}</span>;
          }
        },
        {
          title: '受保人年龄',
          align: 'center',
          key: 'insuranceAge',
          minWidth: 100
        },
        {
          title: '年缴保费',
          align: 'center',
          key: 'paymentPeriod',
          minWidth: 180,
          render(h, params) {
            let paymentPeriod = params.row.paymentPeriod;
            let fee = params.row.fee;
            let currencyType = params.row.currencyType;
            let paymentType = params.row.paymentType;
            let periodUnit = GUARANTEE_TYPE[paymentType] || '年';
            return <span>{fee}{CURRENCY_TYPE[currencyType]}/{paymentPeriod}{periodUnit}</span>;
          }
        },
        {
          title: '签单代理人',
          align: 'center',
          key: 'agentName',
          minWidth: 180,
          renderHeader: (h, params) => {
            return (
              <Poptip trigger="hover" content="content" transfer={true}>
                <span>签单代理人</span>
                <span class="tip-icon">?</span>
                <div slot="content">
                  <p>职级为签单时的职级</p>
                </div>
              </Poptip>
            );
          },
          render(h, params) {
            let agentStaffNo = params.row.agentStaffNo;
            let agentName = params.row.agentName;
            const value = params.row.ifaLevel;
            let ifaLevelMap = {
              0: '',
              1: '萌新',
              2: '新贵',
              3: '精英',
              4: '王者'
            };
            return <span>{agentStaffNo + '/' + agentName}/{ifaLevelMap[value]}</span>;
          }
        },
        {
          title: '佣金项类型',
          align: 'center',
          slot: 'commissionType',
          minWidth: 120
        },
        {
          title: '佣金归属',
          align: 'center',
          key: 'owerName',
          minWidth: 150,
          render(h, params) {
            let owerStaffNo = params.row.owerStaffNo;
            let owerName = params.row.owerName;
            return <span>{owerStaffNo + '/' + owerName}</span>;
          }
        },
        {
          title: '当前职级',
          align: 'center',
          key: 'ifaLevel',
          minWidth: 100,
          render(h, params) {
            const value = params.row.ifaLevel;
            let ifaLevelMap = {
              0: '',
              1: '萌新',
              2: '新贵',
              3: '精英',
              4: '王者'
            };
            return <span>{ifaLevelMap[value]}</span>;
          }
        },
        {
          title: '佣金率(%)',
          align: 'center',
          key: 'commission',
          minWidth: 120
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
          fixed: 'right',
          minWidth: 130
        }
      ];

      this.extraColumns = [
        {
          type: "selection",
          width: 60,
          align: "center",
          fixed: 'left'
        },
        {
          title: 'IFA',
          align: 'center',
          key: 'owerName',
          minWidth: 120,
          fixed: 'left'
        },
        {
          title: '职级',
          align: 'center',
          key: 'owerLevel',
          minWidth: 100,
          render(h, params) {
            return <span>{IFA_RANK[params.row.owerLevel] || '-'}</span>;
          }
        },
        {
          title: '保单编号',
          align: 'center',
          key: 'policyNo',
          minWidth: 120
        },
        {
          title: '佣金项类型',
          align: 'center',
          key: 'commissionType',
          minWidth: 120,
          render(h, params) {
            const value = params.row.commissionType;
            let commissionTypeMap = {
              1: '周边收支',
              2: '佣金调整'
            };
            return <span>{commissionTypeMap[value]}</span>;
          }
        },
        {
          title: '积分（港币）',
          align: 'center',
          key: 'settleCommissionPrice',
          minWidth: 130
        },
        {
          title: '收支类型',
          align: 'center',
          key: 'incomeType',
          minWidth: 100,
          render(h, params) {
            const value = params.row.incomeType;
            if (value == 1) return <span>收入</span>;
            if (value == 2) return <span>支出</span>;
            return <span>-</span>;
          }
        },
        {
          title: '备注',
          align: 'center',
          key: 'remark',
          minWidth: 150,
          render(h, params) {
            return <span>{params.row.remark || '-'}</span>;
          }
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ];
    }
  }
};
